import { ChartKey, varId } from '../types'
import { GraphResult } from './orderGraph'

/** 'white' = referenced by a condition but direction not entailed (assigned in
 *  assignValues); candleColor() itself only ever returns green/red/gray. */
export type CandleColor = 'green' | 'red' | 'gray' | 'white'

/**
 * A candle is colored only when the constraint graph ENTAILS its direction —
 * directly (`close > open`) or transitively (`close > X`, `X > open`). All
 * other candles stay neutral gray (spec §7.6).
 */
export const candleColor = (graph: GraphResult, chartKey: ChartKey, bar: number): CandleColor => {
  const close = varId(chartKey, 'candle.close', bar)
  const open = varId(chartKey, 'candle.open', bar)
  if (graph.entails(close, open)) return 'green'
  if (graph.entails(open, close)) return 'red'
  return 'gray'
}
